import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import FormularioContacto from "./formulario_contacto";

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <FormularioContacto/>
  </StrictMode>
);